import { useEffect, useRef, useState } from "react";
import BuilderListLayout from "../../Builder/BuilderListLayout/BuilderListLayout";
import ForumTable from "./ForumTable";
import { useNavigate } from "react-router-dom";
import { getAPI } from "../../../../../API/ApiService";
import { BASE_URL } from "../../../../../constant/apiUrl";
import { useDispatch } from "react-redux";
import { setForumList } from "../../../../../slices/forumBuilderSlice";
import { formatDate } from "../../../../../utils/function";

const ForumList = () => {
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleSearch = (value) => {
    setSearchText(value);
  };
  const hasfetched = useRef();
  const createForum = () => {
    navigate("/admin/forum");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAPI(`${BASE_URL}/forum/list`);
        if (response?.status === 200) {
          const fetchData = response?.data?.map((item) => {
            return {
              ...item,
              status: item?.status ? "Active" : "Inactive",
              createdDate: formatDate(item?.createdDate),
              updatedDate: formatDate(item?.updatedDate),
            };
          });

          dispatch(setForumList(fetchData));
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };
    if (!hasfetched.current) {
      hasfetched.current = true;
      fetchData();
    }
  }, []);

  return (
    <BuilderListLayout
      title="Forum builder"
      headerTitle="Current forums"
      buttonTitle="Create new forum"
      handleSearch={handleSearch}
      onClick={createForum}
      backlabel="Back to forum list"
    >
      <ForumTable searchText={searchText} loading={loading} />
    </BuilderListLayout>
  );
};

export default ForumList;
